import * as React from "react";
import Svg, { Path } from "react-native-svg";
const Processing = (props) => (
  <Svg
    width={16}
    height={14}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M6.58103 0.628745L0.176624 11.2165C0.0609374 11.4077 2.14111e-05 11.6246 5.64322e-09 11.8454C-2.13998e-05 12.0662 0.0608525 12.2831 0.176502 12.4743C0.292151 12.6656 0.458499 12.8244 0.658824 12.9348C0.859149 13.0451 1.08639 13.1033 1.3177 13.1032H14.1255C14.3568 13.1033 14.584 13.0451 14.7844 12.9348C14.9847 12.8244 15.151 12.6656 15.2667 12.4743C15.3823 12.2831 15.4432 12.0662 15.4432 11.8454C15.4432 11.6246 15.3822 11.4077 15.2666 11.2165L8.86284 0.628745C8.74721 0.437582 8.5809 0.278839 8.38063 0.168471C8.18036 0.0581037 7.95319 0 7.72194 0C7.49068 0 7.26351 0.0581037 7.06324 0.168471C6.86297 0.278839 6.69666 0.437582 6.58103 0.628745Z"
      fill="#02BC7D"
    />
    <Path
      d="M7.80535 3.89453H7.63829C7.22698 3.89453 6.89355 4.2128 6.89355 4.60541V8.00331C6.89355 8.39592 7.22698 8.7142 7.63829 8.7142H7.80535C8.21666 8.7142 8.55009 8.39592 8.55009 8.00331V4.60541C8.55009 4.2128 8.21666 3.89453 7.80535 3.89453Z"
      fill="#FFF7ED"
    />
    <Path
      d="M7.72182 11.4094C8.17926 11.4094 8.55009 11.0554 8.55009 10.6187C8.55009 10.1821 8.17926 9.82812 7.72182 9.82812C7.26438 9.82812 6.89355 10.1821 6.89355 10.6187C6.89355 11.0554 7.26438 11.4094 7.72182 11.4094Z"
      fill="#FFF7ED"
    />
  </Svg>
);
export default Processing;
